<script>
  import Icon from '../../Icon/Icon.vue';

  export default {
    name: 'list-header',

    components: {
      'll-icon': Icon,
    },

    props: {
      /**
       * keys to be sorted for the column
       * the first key should be the default sort value
       */
      sortKeys: {
        type: Array,
        required: true,
        validator: (value) => value.length === 2,
      },

      listViewRef: {
        type: Object,
        default: null,
      },
    },

    data() {
      return {
        isAscending: null,
      };
    },

    computed: {
      listViewInstance() {
        return this.listViewRef || this.$parent;
      },
      /**
       * Is the column currently sorted
       */
      isSorted() {
        return this.sortKeys.includes(this.listViewInstance.sortTerm);
      },

      /**
       * Show the top icon if it's not sorted or if the current sortTerm matches
       */
      showCaretUp() {
        return this.isAscending === null || this.sortKeys[0] === this.listViewInstance.sortTerm;
      },

      /**
       * Show the bottom icon if it's not sorted or if the current sortTerm matches
       */
      showCaretDown() {
        return this.isAscending === null || this.sortKeys[1] === this.listViewInstance.sortTerm;
      },
    },

    watch: {
      isSorted: {
        handler(value) {
          this.isAscending = value ? true : null;
        },
        immediate: true,
      },
    },

    methods: {
      /**
       * Sorts the column by the sort field
       */
      sort() {
        this.listViewInstance.onSort(this.sortKeys[this.isAscending ? 1 : 0]);
        this.isAscending = !this.isAscending;
      },
    },
  };
</script>

<template>
  <div :class="['cursor-pointer', { 'bg-blue-100': isSorted }]" @click="sort">
    <slot></slot>
    <div class="relative h-4 w-3 text-ice-700" :class="{ 'is-active-sort': isSorted }">
      <ll-icon
        v-if="showCaretUp"
        name="caret-up"
        class="absolute"
        :class="[$style.caret, $style['caret-up']]"
        size="dense"
      />
      <ll-icon
        v-if="showCaretDown"
        name="caret-down"
        class="absolute"
        :class="[$style.caret, $style['caret-down']]"
        size="dense"
      />
    </div>
  </div>
</template>

<style module>
  @layer utilities {
    .caret-up {
      top: -5px;
    }

    .caret-down {
      top: 2px;
    }

    :global(.is-active-sort) .caret {
      top: -2px; /* vertically center the caret icon */
    }
  }
</style>
